import { Box, Button, Divider, Tooltip, Typography, useMediaQuery } from "@mui/material";
import { FC, useMemo } from "react";
import { FormDistribuidorRevenda } from "../FormDistribuidorRevenda";
import { BottomBar } from "src/framework/components/commons/BottomBar";
import { PageTitle } from "../PageTitle";
import { FormProjetoOffGridType } from "../types";
import { ValidateUtil } from "src/framework/commons/ValidateUtil";
import { FormClienteOffGrid } from "./FormClienteOffGrid";
import { ModalEquipamentos } from "./ModalEquipamentos";
import { useProjetosOffGridStore } from "src/store/vendas/projetos/offgrid.store";
import theme from "src/theme/light";
import { OrientacoesDimensionado } from "./FormClienteOffGrid/containers/OrientacoesDimensionado";

const tipoProjetoString: { [index: string]: { [index: string]: string } } = {
  "dimensionado": {
    "distribuicao_offgrid": "dimensionado Off Grid",
  },
}

interface FormDadosOffGridProperties {
    formState: FormProjetoOffGridType;
    onChangeValue: (formState: Partial<FormProjetoOffGridType>) => void
    errorState: string[];
    onChangeError: (errorState: string) => void
    distribuidorRevendaUsuario: any
    onClickNext: () => void
}

// const useStyles = makeStyles({
//   customButton: {
//     backgroundColor: '#CC8F00'
//   },
// })

export const FormDadosOffGrid: FC<FormDadosOffGridProperties> = ({ onClickNext, formState, onChangeValue, errorState, onChangeError, distribuidorRevendaUsuario }) => {
  const { changeModalsValue } = useProjetosOffGridStore(store => store.actions)

  const projetosOffGridValidationsStoreState = useProjetosOffGridStore(store => store.state.validations)
  const projetosOffGridModalsStoreState = useProjetosOffGridStore(store => store.state.modals)

  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const FooterBottom = isMobile ? Box : BottomBar;

  const nextButtonIsDisabled = useMemo(() => {
    const validationsStoreFields: (keyof typeof projetosOffGridValidationsStoreState)[] = ["modulo", 'autonomia_bancos_bateria', 'tipo_bateria']

    const validationStoreIsInvalid = validationsStoreFields.some(item => {
      return !projetosOffGridValidationsStoreState[item].status
    })

    if (validationStoreIsInvalid) return true;

    const requiredFields: (keyof FormProjetoOffGridType)[] = [
      "cliente_proposta",
      "cidade",
      "estado",
      'total_consumo_diario_kw',
      'total_consumo_diario_w',
      'autonomia_banco_bateria',
      'tensao_saida',
      'modulo_selecionado',
      'estrutura_selecionada',
      "latitude",
      "longitude",
      'tipo_bateria',
      'geracao_necessaria_w',
      'geracao_necessaria_kw'
    ]

    if (!formState.baterias.length) return true;

    for (const requiredField of requiredFields) {
      if (!formState?.[requiredField]) {
        return true;
      }
    }

    if (formState?.email_proposta && (!ValidateUtil.isValidEmail(formState?.email_proposta) || errorState?.includes('email_proposta'))) return true;
    
    if (formState?.cep && formState?.cep?.length < 9) return true;

  }, [projetosOffGridValidationsStoreState, formState, errorState])

  const pageTitle = useMemo(()=>{
    if (!formState?.tipo || !formState?.segmento) return '';
    const tipoString = tipoProjetoString[formState.tipo][formState.segmento] || formState.tipo;
    
    if (!formState?.clonar_projeto && formState?.isEdit) return `Edição de projeto ${tipoString}`
    return `Novo projeto ${tipoString}`
  },[formState?.clonar_projeto, formState?.tipo, formState?.isEdit, formState.segmento])

  return (
    <>
      <Box p={2}>
        <PageTitle title={pageTitle} subtitle='Preencha os dados do cliente' />
      </Box>

      <Divider className="X12" />

      <Box p={2}>
        <Box className="X12" py={2}>
          <Typography variant="h6" align="left"><strong>Dados do cliente:</strong></Typography>
        </Box>

        <FormDistribuidorRevenda
          errorState={errorState}
          formState={formState}
          distribuidorRevendaUsuario={distribuidorRevendaUsuario}
          onChangeError={onChangeError}
          onChangeValue={onChangeValue}
        />

        <FormClienteOffGrid
          errorState={errorState}
          onChangeError={onChangeError}
          formState={formState}
          onChangeValue={onChangeValue}
        />
      </Box>

      <OrientacoesDimensionado />      

      <FooterBottom className="fotter-bottom">
        <Tooltip title={nextButtonIsDisabled ? 'Para prosseguir, preencha os campos marcados como *obrigatório.' : ''}>
          <span>
            <Button
              disableElevation={true}
              disabled={nextButtonIsDisabled}
              color={"primary"}
              variant={"contained"}
              onClick={onClickNext}
              fullWidth={isMobile}
              >
              Continuar meu projeto
            </Button>
          </span>
        </Tooltip>

        { nextButtonIsDisabled && isMobile && <Box className="label-inputs" color="">
          <small>Para prosseguir, preencha os campos marcados como <span className="label-emphasis">*</span>obrigatório.</small>
        </Box>}
      </FooterBottom>

        {projetosOffGridModalsStoreState.equipamentos && (
          <ModalEquipamentos
            open={projetosOffGridModalsStoreState.equipamentos}
            onClose={() => changeModalsValue({ equipamentos: false })}
            initialData={formState?.equipamentos || []}
            onChangeValue={(equipamentos) => onChangeValue(equipamentos)}
          />
        )}
    </>
  )
}
